export default class BaseRoute {
  static isRouteClass = true;

  static getInstance(obj) {
    let instance = new obj();
    Object.assign(instance, obj.__services);
    return instance;
  }
}